import { render, staticRenderFns } from "./halls-boothclaim.vue?vue&type=template&id=ab844d8e&scoped=true&"
import script from "./halls-boothclaim.vue?vue&type=script&lang=js&"
export * from "./halls-boothclaim.vue?vue&type=script&lang=js&"
import style0 from "./halls-boothclaim.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./halls-boothclaim.vue?vue&type=style&index=1&id=ab844d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab844d8e",
  null
  
)

export default component.exports